export default __webpack_public_path__ + "static/faq-cc49dba8d5cb23fc9eeb85375cfc5ea9.jpg";